
import data from '@/assets/data/redirects.json'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!import.meta.server) return

  const redirect = await useFetch('/store-api/scop_platform_redirect_redirect', {
    method: 'POST',
    body: {
      limit: 1,
      sort: [{ field: 'createdAt', order: 'desc' }],
      filter: [
        { type: 'equals', field: 'enabled', value: true },
        { type: 'equals', field: 'sourceURL', value: to.path }
      ]
    }
  })

  const redirectData = (redirect.data.value as { elements: { httpCode: number; targetURL: string; ignoreQueryParams: boolean }[] }).elements[0]
  if (redirectData) {
    const redirectOptions = { redirectCode: redirectData.httpCode }
    const target = redirectData.ignoreQueryParams ? redirectData.targetURL : { path: redirectData.targetURL, query: to.query }

    return navigateTo(target, redirectOptions)
  }

  const localMatch = data.find(({ old, regexp }) => { return regexp ? new RegExp(old).test(to.path) : old === to.path })
  if (localMatch) {
    return navigateTo(localMatch.new, { redirectCode: 301 })
  }

  if (to.name !== 'k-id') {
    return
  }

  const getCategory = await useFetch(`/store-api/url/${to.params.id}`, {
    method: 'POST',
    body: {
      includeCategoryFooterMediaExtension: true,
      includes: {
        category: ['customFields']
      }
    },
    query: {
      url: to.path
    }
  })

  if (getCategory) {
    const categoryData = getCategory.data.value as { customFields: { [key: string]: any } }
    const categoryCustomFields = categoryData.customFields
    if (categoryCustomFields['category_isBaseCategory']) {
      const path = to.path.replace("/k/", "/b/");

      return navigateTo(path, { redirectCode: 301 })
    }
  }
})
